import { IFadeTrackConf } from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";

import { DDD } from "../../game/DDD";
import { EventsManager, SoundEvents } from "../events/EventsManager";
import { SoundConfig } from "../types/interfaces";

export const playSound = (soundConfig: SoundConfig): void => {
    const newVolume = soundConfig.volume || 1;

    EventsManager.trigger(SoundEvents.PLAY_SOUND, { ...soundConfig, volume: newVolume });
};

export const playSoundOnce = (soundConfig: SoundConfig): void => {
    const newVolume = soundConfig.volume || 1;

    EventsManager.trigger(SoundEvents.PLAY_SOUND_ONCE, { ...soundConfig, volume: newVolume });
};

export const playBackgroundMusic = (): void => {
    EventsManager.trigger(SoundEvents.PLAY_BACKGROUND_MUSIC, DDD.model.data.mode);
};

export const playNextBackgroundMusic = (): void => {
    EventsManager.trigger(SoundEvents.PLAY_BACKGROUND_MUSIC, DDD.model.data.nextMode);
};

export const fadeInBackgroundMusic = (duration: number = 0.1): void => {
    const finalDuration = duration * 1000;

    EventsManager.trigger(SoundEvents.FADE_IN_BACKGROUND_MUSIC, finalDuration);
};
export const fadeOutBackgroundMusic = (duration: number = 0.1): void => {
    const finalDuration = duration * 1000;

    EventsManager.trigger(SoundEvents.FADE_OUT_BACKGROUND_MUSIC, finalDuration);
};

export const fadeOutAndStopBackgroundMusic = (duration: number = 0.1): void => {
    const finalDuration = duration * 1000;

    EventsManager.trigger(SoundEvents.FADE_OUT_BACKGROUND_MUSIC, finalDuration);
};

export const fadeSound = (config: IFadeTrackConf): void => {
    config.duration *= 1000;
    EventsManager.trigger(SoundEvents.FADE_SOUND, config);
};

export const fadeAndStopSound = (config: IFadeTrackConf): void => {
    EventsManager.trigger(SoundEvents.FADE_AND_STOP_SOUND, config);
};

export const stopSound = (config: SoundConfig): void => {
    EventsManager.trigger(SoundEvents.STOP_SOUND, config);
};

export const stopBackgroundMusic = (): void => {
    EventsManager.trigger(SoundEvents.STOP_BACKGROUND_MUSIC);
};

export const stopAmbSounds = (): void => {
    EventsManager.trigger(SoundEvents.STOP_AMBIANCE_SOUNDS);
};

export const startAmbSounds = (): void => {
    EventsManager.trigger(SoundEvents.START_AMBIANCE_SOUNDS);
};
